import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from './Heading.styles';
import {
  getRenderInternationalForm,
  getRenderUnitedStatesForm,
} from '../../../store/selectors/CountryStateOrg';
import RequiredFieldsNote from '../RequiredFieldsNote/RequiredFieldsNote';
import { getLoginStep } from '../../../store/selectors/TenantPickerState';

const getTitleId = (loginStep, hasInternational, hasUnitedStates) => {
  if (loginStep > 1) {
    return 'tenantPicker.signIn';
  }
  if (hasInternational) {
    return 'tenantPicker.selectOrganization';
  }
  if (hasUnitedStates) {
    return 'tenantPicker.selectDistrictSchool';
  }

  return 'tenantPicker.signIn';
};

const Heading = () => {
  const { classes } = useStyles();
  const hasInternational = useSelector(getRenderInternationalForm);
  const hasUnitedStates = useSelector(getRenderUnitedStatesForm);
  const loginStep = useSelector(getLoginStep);
  const titleId = getTitleId(loginStep, hasInternational, hasUnitedStates);

  if (loginStep === 3) return null;

  return (
    <div className={classes.root}>
      <Typography component="h1" variant="h3">
        <FormattedMessage id={titleId} />
      </Typography>
      <RequiredFieldsNote />
    </div>
  );
};

export default Heading;
